import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { EditPecMetadataModalComponent } from './edit-pec-metadata-modal';

export const EditPecMetadataModalModule: string = ng
    .module('edit-pec-metadata-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('editPecMetadataModalComponent', EditPecMetadataModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/edit-pec-metadata-modal/edit-pec-metadata-modal.module.ts